/** Created by azhou on 2019/3/25.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.order_name}}</li>
    <li class="w-50 list-item-col">
      <span class="text-warning" v-if="Itemize.reply===''">{{Itemize.comment_store_type | formatVar('StoreType')}}评论</span>
      <span class="text-success" v-else>{{Itemize.reply_store_type | formatVar('StoreType')}}回复</span>
    </li>
    <li class="w-50 list-item-col">{{time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col">
      <span class="text-link" @click="goForDetail">查看详情</span>
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'AdminItemize',
    props:{
      Itemize:{}
    },
    computed:{
      time() {
        return this.Itemize.reply_time || this.Itemize.comment_time;
      }
    },
    methods:{
    goForDetail() {
      if (!this.$GFUN.powerIsInArray([126])) { this._alert('您没有相关权限！',null,'error'); return; }
      this.$router.push({name:'CommentDetail',query:{commentId:this.Itemize.id}});
    }
    }
  }
</script>
